(function () {
  var DETAIL_SELECTOR = [
    '.wubs-pdp-side__variant-dropdown',
    '.wubs-pdp-side__special-item',
    '.wubs-coll-filters__group',
    '.wubs-cd__note',
    '.wubs-mm__item > details',
    '.product__accordion details',
    '.collapsible-content details'
  ].join(',');

  var DURATION = 280;
  var EASING = 'cubic-bezier(.33, 1, .68, 1)';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function injectStyles() {
    if (document.getElementById('wubs-animated-details-style')) return;

    var style = document.createElement('style');
    style.id = 'wubs-animated-details-style';
    style.textContent = [
      '.wubs-animated-details__content{overflow:hidden;}',
      '.wubs-animated-details.is-closing.wubs-pdp-side__variant-dropdown .wubs-pdp-side__variant-select-icon{transform:translateY(-50%) rotate(0deg)!important;}',
      '.wubs-animated-details.is-closing.wubs-pdp-side__special-item .wubs-pdp-side__special-icon svg{transform:rotate(0deg)!important;}',
      '.wubs-animated-details.is-closing.wubs-cd__note .wubs-cd__noteChev{transform:rotate(0deg)!important;}',
      '.wubs-animated-details.is-closing .wubs-mm__chev{transform:rotate(0deg)!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function getDirectSummary(details) {
    return details.querySelector(':scope > summary');
  }

  function ensureContent(details, summary) {
    var existing = details.querySelector(':scope > .wubs-animated-details__content');
    if (existing) return existing;

    var content = document.createElement('div');
    content.className = 'wubs-animated-details__content';

    while (summary.nextSibling) {
      content.appendChild(summary.nextSibling);
    }

    details.appendChild(content);
    return content;
  }

  function cleanup(details, content) {
    window.clearTimeout(details.__wubsAnimatedTimer);
    if (details.__wubsAnimatedEnd) {
      content.removeEventListener('transitionend', details.__wubsAnimatedEnd);
    }

    details.__wubsAnimatedTimer = null;
    details.__wubsAnimatedEnd = null;
  }

  function setExpanded(summary, expanded) {
    summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function resetContentStyles(content) {
    content.style.height = '';
    content.style.opacity = '';
    content.style.transform = '';
    content.style.overflow = '';
    content.style.transition = '';
  }

  function finishAfterHeight(details, content, callback) {
    var done = function (event) {
      if (event && event.target !== content) return;
      if (event && event.propertyName && event.propertyName !== 'height') return;

      cleanup(details, content);
      callback();
    };

    details.__wubsAnimatedEnd = done;
    content.addEventListener('transitionend', done);
    details.__wubsAnimatedTimer = window.setTimeout(done, DURATION + 90);
  }

  function openDetails(details, summary, content) {
    cleanup(details, content);

    if (reducedMotion.matches) {
      details.open = true;
      details.classList.add('is-open');
      details.classList.remove('is-closing', 'is-opening');
      resetContentStyles(content);
      setExpanded(summary, true);
      return;
    }

    details.open = true;
    details.classList.add('is-opening', 'is-open');
    details.classList.remove('is-closing');
    setExpanded(summary, true);

    content.style.overflow = 'hidden';
    content.style.height = '0px';
    content.style.opacity = '0';
    content.style.transform = 'translateY(-4px)';
    content.style.transition = 'none';

    content.offsetHeight;

    window.requestAnimationFrame(function () {
      content.style.transition = 'height ' + DURATION + 'ms ' + EASING + ', opacity 180ms ease, transform ' + DURATION + 'ms ' + EASING;
      content.style.height = content.scrollHeight + 'px';
      content.style.opacity = '1';
      content.style.transform = 'translateY(0)';
    });

    finishAfterHeight(details, content, function () {
      details.classList.remove('is-opening');
      resetContentStyles(content);
    });
  }

  function closeDetails(details, summary, content) {
    cleanup(details, content);

    if (reducedMotion.matches) {
      details.open = false;
      details.classList.remove('is-open', 'is-closing', 'is-opening');
      resetContentStyles(content);
      setExpanded(summary, false);
      return;
    }

    details.classList.add('is-closing');
    details.classList.remove('is-opening', 'is-open');
    setExpanded(summary, false);

    content.style.overflow = 'hidden';
    content.style.height = content.scrollHeight + 'px';
    content.style.opacity = '1';
    content.style.transform = 'translateY(0)';
    content.style.transition = 'none';

    content.offsetHeight;

    window.requestAnimationFrame(function () {
      content.style.transition = 'height ' + DURATION + 'ms ' + EASING + ', opacity 180ms ease, transform ' + DURATION + 'ms ' + EASING;
      content.style.height = '0px';
      content.style.opacity = '0';
      content.style.transform = 'translateY(-4px)';
    });

    finishAfterHeight(details, content, function () {
      details.open = false;
      details.classList.remove('is-closing');
      resetContentStyles(content);
    });
  }

  function shouldSkip(details) {
    if (details.dataset.wubsNoAnimate === 'true') return true;
    if (details.closest('details-disclosure, header-menu, details-modal')) return true;
    if (details.matches('.disclosure-has-popup, .mobile-facets__disclosure, .facets__disclosure, .facets__disclosure-vertical')) return true;
    return false;
  }

  function initDetails(details) {
    if (!details || details.dataset.wubsAnimatedDetails === 'true') return;
    if (!details.matches(DETAIL_SELECTOR) || shouldSkip(details)) return;

    var summary = getDirectSummary(details);
    if (!summary) return;

    var content = ensureContent(details, summary);
    if (!content || !content.childNodes.length) return;

    details.dataset.wubsAnimatedDetails = 'true';
    details.classList.add('wubs-animated-details');
    details.classList.toggle('is-open', details.open);
    setExpanded(summary, details.open);

    summary.addEventListener('click', function (event) {
      event.preventDefault();

      if (details.open && !details.classList.contains('is-closing')) {
        closeDetails(details, summary, content);
      } else {
        openDetails(details, summary, content);
      }
    });
  }

  function init(root) {
    injectStyles();

    if (root && root.matches && root.matches(DETAIL_SELECTOR)) {
      initDetails(root);
    }

    Array.prototype.slice.call((root || document).querySelectorAll(DETAIL_SELECTOR)).forEach(initDetails);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('wubs:cart-updated', function () {
    window.setTimeout(function () {
      init(document);
    }, 0);
  });

  var observer = new MutationObserver(function (mutations) {
    var shouldInit = mutations.some(function (mutation) {
      return Array.prototype.slice.call(mutation.addedNodes).some(function (node) {
        return node.nodeType === 1 && ((node.matches && node.matches(DETAIL_SELECTOR)) || (node.querySelector && node.querySelector(DETAIL_SELECTOR)));
      });
    });

    if (shouldInit) {
      window.requestAnimationFrame(function () {
        init(document);
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
